@let backgroundImageUrl = backgroundImage();
@let showBackgroundImage = !isHighContrastEnabled() && backgroundImageUrl;

<div class="flex" [class.hidden]="!isTranslationLoaded()">
  <div
    class="theme-text-color page flex flex-column min-h-screen w-full"
    [style.background-image]="showBackgroundImage ? 'url(' + backgroundImageUrl + ')' : null"
    [class.self-registration]="isSelfRegistration()"
    [class.page-background-with-image]="showBackgroundImage"
    [class.page-background-without-image]="isHighContrastEnabled() || !backgroundImageUrl"
    (contextmenu)="onRightClick($event)"
  >
    <ls-toast-simple />

    <ls-sidebar
      class="basket-sidebar"
      data-nested-translation="navigation.basket"
      appAddAttributes
      [addAttributes]="{ '.close-sidebar button': { 'aria-label': 'a11y.basket.heading.close' | translate } }"
      [loading]="false"
      [show]="isBasketOpen()"
      [title]="'navigation.basket' | translate | hideTranslation"
      [size]="'sm'"
      (onClose)="onCloseBasket($event)"
    >
      <app-basket (isBasketOpenEvent)="onIsBasketOpen($event)" />
    </ls-sidebar>

    <app-top-bar
      class="sticky top-0 z-3"
      [isBasketOpen]="isBasketOpen()"
      [isMobileMenuOpen]="isMobileMenuOpen()"
      (isBasketOpenEvent)="onIsBasketOpen($event)"
      (isMobileMenuOpenEvent)="onIsMobileMenuOpen($event)"
    />

    <main class="z-2 flex-grow-1">
      <router-outlet />
    </main>

    <app-footer class="z-2" />

    @if (!isSelfRegistration()) {
      <app-browser-check />
    }

    <app-bottom-sticky />
  </div>
</div>

@if (!isTranslationLoaded()) {
  <app-big-loader />
}

@if (isLoggedInAsAdmin()) {
  <app-colorizer (contextmenu)="onRightClick($event)" />
}

<app-accessibility-sidebar (contextmenu)="onRightClick($event)" />

<ls-modal
  data-nested-translation="step-navigation.reload-required"
  [title]="'step-navigation.reload-required' | translate | hideTranslation"
  [visible]="isReloadModalWindowOpen()"
  [closable]="false"
  [footerContent]="false"
  (contextmenu)="onRightClick($event)"
>
  <div class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      data-nested-translation="ticket.timeout.modalWindow.close"
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'ticket.timeout.modalWindow.close' | translate | hideTranslation"
      (onClick)="onCloseModalWindow($event)"
    />
  </div>
</ls-modal>

<ls-modal
  [title]="'invalid-form-redirect.buyer-information.modal.title' | translate | hideTranslation"
  [visible]="isInvalidBuyerInformationStepModalOpen()"
  [closable]="false"
  [footerContent]="false"
  (contextmenu)="onRightClick($event)"
>
  <div class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'invalid-form-redirect.buyer-information.modal.button.confirm' | translate | hideTranslation"
      (onClick)="onRedirectToBuyerInformationStep($event)"
    />
  </div>
</ls-modal>

<ls-modal
  data-nested-translation="order.duplicates-warning.modalWindow.title"
  [title]="'order.duplicates-warning.modalWindow.title' | translate | hideTranslation"
  [visible]="isDuplicateEmailAddressWarningMessageModalOpen()"
  [closable]="false"
  [footerContent]="false"
  (contextmenu)="onRightClick($event)"
>
  <div class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      data-nested-translation="order.duplicates-warning.modalWindow.close"
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'order.duplicates-warning.modalWindow.close' | translate | hideTranslation"
      (onClick)="onCloseDuplicateEmailAddressWarningMessageModal($event)"
    />
  </div>
</ls-modal>

<app-ticket-limit-per-email-address-modal
  [ticketLimitPerEmail]="ticketLimitPerEmail()"
  [isModalOpen]="
    ticketLimitPerEmailAddressWarningMessageModalState().isOpen &&
    !ticketLimitPerEmailAddressWarningMessageModalState().isAlreadyShown
  "
  (ticketOverLimitModalClosedEvent)="onCloseTicketLimitPerEmailAddressWarningMessageModal()"
  (contextmenu)="onRightClick($event)"
/>

<app-verify-phone-modal (contextmenu)="onRightClick($event)" />
